import { render, staticRenderFns } from "./bo-announcement.vue?vue&type=template&id=50ed6a0a"
import script from "./bo-announcement.vue?vue&type=script&lang=js"
export * from "./bo-announcement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports